// extracted by mini-css-extract-plugin
export var Section = "Apartments-module--Section--Q-S-0";
export var Header = "Apartments-module--Header--OntbN";
export var SectionTitle = "Apartments-module--SectionTitle--4vWZ7";
export var Title = "Apartments-module--Title--tVtDv";
export var Controls = "Apartments-module--Controls--wEg0T";
export var SecondSection = "Apartments-module--SecondSection--4WA6s";
export var Prev = "Apartments-module--Prev--KZzpw";
export var Next = "Apartments-module--Next--UAHO1";
export var Slider = "Apartments-module--Slider--ShRy6";
export var Slide = "Apartments-module--Slide--ucjxI";
export var Image = "Apartments-module--Image--Z1aI1";
export var Desc = "Apartments-module--Desc--brfWo";
export var arrowLeft = "Apartments-module--arrowLeft--W0l78";
export var arrowRight = "Apartments-module--arrowRight--448JJ";